import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from '@material-ui/core/Tooltip';
import styled from "styled-components";

/*
<DarkTooltip
  arrow
  title={
    <TipContent>
      <p style={{display: 'flex', alignItems: 'center'}}><Dot borderColor="1px solid #FFF" style={{marginRight: '8px'}} /> No food was logged</p>
    </TipContent> 
  }
  key={i}
>
  <p>Content</p>
</DarkTooltip>
*/
const CustomDarkTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#08091f',
    color: '#FFFFFF',
    borderRadius: '12px',
    boxShadow: theme.shadows[1],
    fontFamily: 'DM Sans',
    fontSize: 12,
  },
  arrow: {
    color: '#08091f'
  }
}))(Tooltip);

const TipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px;
  p {
    font-size: .9rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
  li {
    font-size: .9rem;
    font-weight: normal;
    margin-bottom: 4px;
    span {
      font-weight: bold;
    }
  }
  span {
    font-size: .9rem;
    font-weight: normal;
    text-align: center;
    margin-bottom: 4px;
  }
`;

export const DarkTooltip = ({children, title, placement}) => (
  <CustomDarkTooltip
    arrow
    enterDelay={1300}
    title={
      <TipContent>
        {title}
      </TipContent>
    }
    placement={placement}
  >
    {children}
  </CustomDarkTooltip>
)
